import { Component, ElementRef, ViewChild, HostListener, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { StaffServiceService } from '../staff/service/staff-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-dialer-wrapper',
  template: `
    <div class="wrapper-container">
      <iframe
        *ngIf="hrmsUrl"
        #appIframe
        [src]="hrmsUrl"
        (load)="onIframeLoad()"
        width="100%"
        height="100%"
        style="border: none;"
        title="Dialer Application"
        loading="lazy"
        allow="geolocation; microphone; camera; payment *; clipboard-write; clipboard-read;layout-animations;"
      ></iframe>
      
      <!-- Optional Loading Indicator if hrmsUrl isn't ready -->
      <div *ngIf="!hrmsUrl" class="loader-overlay">
        <div class="spinner"></div>
      </div>
    </div>
  `,
  styles: [
    `
    .wrapper-container {
      position: relative;
      width: 100%;
      height: 100%;
    }
    .loader-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: #ffffff;
      z-index: 10;
      text-align: center;
    }
    .spinner {
      border: 8px solid #f3f3f3;
      border-top: 8px solid #3498db;
      border-radius: 50%;
      width: 60px;
      height: 60px;
      animation: spin 1.5s linear infinite;
    }
    .loader-overlay p {
      margin-top: 15px;
      font-family: sans-serif;
      color: #555;
    }
    .error-text {
      color: #d9534f;
      font-weight: bold;
    }
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    `
  ]
})
export class DialerWrapperComponent implements OnInit, OnDestroy {
  @ViewChild('appIframe') iframe!: ElementRef<HTMLIFrameElement>;
  isHrmsLoaded = false;
  private messageListener: any;
  hrmsUrl!: SafeResourceUrl;

  constructor(
    private router: Router,
    private sanitizer: DomSanitizer,
    private location: Location,
    private staffService: StaffServiceService
  ) { }

  ngOnInit(): void {
    // 1. Get current path from Angular Router, default to dashboard.
    const currentPath = this.location.path() || '/admin/dialer/dashboard';

    // 2. Set the initial URL for the iframe before rendering it.
    const reactBaseUrl = environment.dialerUrl;
    this.hrmsUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${reactBaseUrl}${currentPath}`);

    // 3. Setup postMessage listener for Route Changes inside the React Sidebar/UI
    this.messageListener = (event: MessageEvent) => {
      // Ensure it's listening for route_change and updating Angular 
      if (event.data?.type === 'route_change' && event.data.path) {
        if (window.location.pathname !== event.data.path) {
          this.location.go(event.data.path);
        }
      }
    };

    window.addEventListener('message', this.messageListener);
  }

  ngOnDestroy(): void {
    if (this.messageListener) {
      window.removeEventListener('message', this.messageListener);
    }
  }

  onIframeLoad(): void {
    const iframeContentWindow = this.iframe?.nativeElement?.contentWindow;
    if (iframeContentWindow) {
      const bDetails = localStorage.getItem('bDetails');
      const staffType = localStorage.getItem('staffType');
      const staffId = localStorage.getItem('staffId');
      const staffName = localStorage.getItem('staffName');
      const staffEmail = localStorage.getItem('staffEmail');
      const businessId = localStorage.getItem('businessId');
      const business = localStorage.getItem('business');
      const mobileLogin = localStorage.getItem('mobileLogin');

      const path = this.location.path();

      let isAdmin = this.staffService.isStaffAdmin();
      if (isAdmin) {
        iframeContentWindow.postMessage({ type: 'isAdmin', data: JSON.stringify(true) }, '*');
      } else {
        iframeContentWindow.postMessage({ type: 'isAdmin', data: JSON.stringify(false) }, '*');
      }

      iframeContentWindow.postMessage({ type: 'set_path', path }, '*');
      iframeContentWindow.postMessage({ type: 'localStorage', data: JSON.stringify(bDetails) }, '*');
      iframeContentWindow.postMessage({ type: 'staffType', data: JSON.stringify(staffType) }, '*');
      iframeContentWindow.postMessage({ type: 'staffId', data: JSON.stringify(staffId) }, '*');
      iframeContentWindow.postMessage({ type: 'staffName', data: JSON.stringify(staffName) }, '*');
      iframeContentWindow.postMessage({ type: 'staffEmail', data: JSON.stringify(staffEmail) }, '*');
      iframeContentWindow.postMessage({ type: 'businessId', data: JSON.stringify(businessId) }, '*');
      iframeContentWindow.postMessage({ type: 'business', data: JSON.stringify(business) }, '*');
      iframeContentWindow.postMessage({ type: 'mobileLogin', data: JSON.stringify(mobileLogin) }, '*');
    }
  }
}
